import { createFetchComponent } from '@well-known-components/fetch-component';
import { createLambdasClient } from 'dcl-catalyst-client/dist/client/LambdasClient';
import { BaseAPI } from './api';
export class PeerAPI extends BaseAPI {
    cache = {};
    lambdasClient;
    constructor(url) {
        super(url);
        this.lambdasClient = createLambdasClient({
            url: `${url}/lambdas`,
            fetcher: createFetchComponent()
        });
    }
    /**
     * Fetches a profile only once by caching the promise
     * to prevent concurrent flying requests
     *
     * @param address - The address of the profile to retrieve.
     */
    async fetchProfile(address, options = { useCache: true }) {
        if (options.useCache && address in this.cache) {
            return this.cache[address];
        }
        this.cache[address] = this.lambdasClient
            .getAvatarsDetailsByPost({ ids: [address.toLowerCase()] })
            .then(profiles => profiles[0]);
        return this.cache[address];
    }
    async fetchProfiles(addresses) {
        if (addresses.length === 0) {
            return [];
        }
        return this.lambdasClient.getAvatarsDetailsByPost({
            ids: addresses.map(address => address.toLowerCase())
        });
    }
    /**
     * Gets the default entity structure for a profile.
     */
    async getDefaultProfileEntity() {
        const profile = await this.request('GET', '/content/entities/profile?pointer=default' +
            Math.floor(Math.random() * 128 + 1));
        return profile[0];
    }
}
//# sourceMappingURL=peer.js.map